import { createAuthInterceptor } from './api-client/AuthInterceptor';
import { createErrorInterceptor } from './api-client/ErrorInterceptor';
import { createRetryInterceptor } from './api-client/RetryInterceptor';
import { createE2EInterceptor } from './api-client/E2EInterceptor';
import { GATEWAY_MAT_COOKIE_KEY } from '~/constants/httpHeader';

export default defineNuxtPlugin(() => {
  const { $apiClient } = useNuxtApp();
  const mat = useCookie(GATEWAY_MAT_COOKIE_KEY);
  const runtimeConfig = useRuntimeConfig();
  const headers = useRequestHeaders();

  $apiClient.addInterceptor(createAuthInterceptor(runtimeConfig.public.APP_ENV, headers, mat.value));
  $apiClient.addInterceptor(createErrorInterceptor());
  $apiClient.addInterceptor(createRetryInterceptor());
  $apiClient.addInterceptor(createE2EInterceptor(runtimeConfig.public.APP_ENV, headers));
});
